import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';
import { SSOProvider } from '../../../../shared/models/enums/auth.enums';
import { LandingV2Properties, LandingV2StoreService } from './landing-v2.component-store';
import { Validators, FormGroupDirective, NonNullableFormBuilder } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { take, filter, takeUntil, finalize, BehaviorSubject } from 'rxjs';
import { HttpExamService } from '../../../../core/services/http/http-exam.service';
import { IsApplicationService } from '../../../../core/services/is-application.service';
import { LanguageService } from '../../../../core/services/language.service';
import { BaseComponent } from '../../../../shared/components/inherited/base/base.component';
import { Exam } from '../../../../shared/models/entities/exam.entity';
import { University } from '../../../../shared/models/entities/university.entity';
import { environment } from '../../../../../environments/environment';
import { supportedScroll } from '../../../../shared/utils/scroll';
import * as GlobalEntitiesActions from '../../../../core/state/global-entities-state/global-entities.actions';
import * as GlobalEntitiesSelectors from '../../../../core/state/global-entities-state/global-entities.selectors';
import * as AuthActions from '../../../../core/state/auth-state/auth.actions';
import * as AuthSelectors from '../../../../core/state/auth-state/auth.selectors';
import { NowService } from '../../../../core/services/now.service';
import { LocaleKeys } from '../../../../shared/utils/locale-keys';
import { Specialty } from '../../../../shared/models/entities/specialty.entity';
import { HttpFeaturedTestimonyService } from '../../../../core/services/http/http-featured-testimony.service';
import { FeaturedTestimony } from '../../../../shared/models/entities/testimony/featured-testimony.entity';
import { FeaturedTestimonyPublicationStatus } from '../../../../shared/models/enums/publication-status.enums';
import { FeaturedTestimonyQueryData } from '../../../../shared/models/payloads/testimony/featured-testimony.payload';
import Swiper from 'swiper';

@Component({
  selector: 'app-landing-v2',
  templateUrl: './landing-v2.component.html',
  styleUrls: ['./landing-v2.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [LandingV2StoreService],
})
export class LandingV2Component extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  LandingV2Properties = LandingV2Properties;

  registerEmail = '';

  exams: Exam[];

  examsSwiper: Swiper;
  @ViewChild('examsSwiper') examsSwiperRef: ElementRef;

  landingTestimonies: FeaturedTestimony[];

  landingTestimoniesSwiper: Swiper;
  @ViewChild('landingTestimoniesSwiper') landingTestimoniesSwiperRef: ElementRef;

  examTypes$ = this.store.select(GlobalEntitiesSelectors.examTypes);

  // nnkitodo [v2later] faire tout ça plus propre
  jQueryScript: HTMLScriptElement;
  bootstrapScript: HTMLScriptElement;
  customScript: HTMLScriptElement;

  animAncrageOptions: AnimationOptions;
  animAncrage$ = new BehaviorSubject<AnimationItem>(undefined);

  animCoursOptions: AnimationOptions;
  animCours$ = new BehaviorSubject<AnimationItem>(undefined);

  animTrainingOptions: AnimationOptions;
  animTraining$ = new BehaviorSubject<AnimationItem>(undefined);

  animTypeOptions: AnimationOptions;
  animType$ = new BehaviorSubject<AnimationItem>(undefined);

  animPlayOptions: AnimationOptions;
  animPlay$ = new BehaviorSubject<AnimationItem>(undefined);

  animEcosOptions: AnimationOptions;
  animEcos$ = new BehaviorSubject<AnimationItem>(undefined);

  animChallengeOptions: AnimationOptions;
  animChallenge$ = new BehaviorSubject<AnimationItem>(undefined);

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private store: Store,
    public languageService: LanguageService,
    public nowService: NowService,
    private httpExamService: HttpExamService,
    private httpFeaturedTestimonyService: HttpFeaturedTestimonyService,
    public componentStore: LandingV2StoreService
  ) {
    super();
    this.jQueryScript = document.createElement('script');
    this.jQueryScript.src = 'assets/scripts/jquery.min.js';
    document.body.appendChild(this.jQueryScript);

    this.jQueryScript.onload = () => {
      this.customScript = document.createElement('script');
      this.customScript.src = 'assets/scripts/custom-designer.js';
      document.body.appendChild(this.customScript);
    };

    this.bootstrapScript = document.createElement('script');
    this.bootstrapScript.src = 'assets/scripts/bootstrap.bundle.js';
    document.body.appendChild(this.bootstrapScript);

    this.animAncrageOptions = {
      path: 'assets/assets-site/animations/ancrage.json',
      autoplay: false,
    };

    this.animCoursOptions = {
      path: 'assets/assets-site/animations/cours.json',
      autoplay: false,
    };

    this.animTrainingOptions = {
      path: 'assets/assets-site/animations/training.json',
      autoplay: false,
    };

    this.animTypeOptions = {
      path: 'assets/assets-site/animations/exam.json',
      autoplay: false,
    };

    this.animPlayOptions = {
      path: 'assets/assets-site/animations/play.json',
      autoplay: false,
    };

    this.animEcosOptions = {
      path: 'assets/assets-site/animations/ecos.json',
      autoplay: false,
    };

    this.animChallengeOptions = {
      path: 'assets/assets-site/animations/challenge.json',
      autoplay: false,
    };
  }

  ngOnInit(): void {
    this.store.dispatch(GlobalEntitiesActions.listExamTypes({ forceUpdate: false }));
  }

  ngAfterViewInit(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params.id;
      setTimeout(() => {
        const sectionToScroll = document.getElementById(id);
        const offset = document.getElementById('navbarContainer').clientHeight;

        if (sectionToScroll) {
          supportedScroll(window, sectionToScroll.offsetTop - offset);
        }
      });
    });

    const thumbnails: any = document.querySelectorAll('.collage__item');

    const observerOptions = {
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry: any) => {
        if (entry.isIntersecting) {
          const index = [...thumbnails].indexOf(entry.target);
          const delay = index * 0.1;
          entry.target.style.transitionDelay = `${delay}s`;
          entry.target.classList.add('fade-in');
        }
      });
    }, observerOptions);

    thumbnails.forEach((thumbnail) => {
      observer.observe(thumbnail);
    });
  }

  ngOnDestroy(): void {
    if (this.jQueryScript && this.jQueryScript.parentNode) {
      document.body.removeChild(this.jQueryScript);
    }
    if (this.bootstrapScript && this.bootstrapScript.parentNode) {
      document.body.removeChild(this.bootstrapScript);
    }
    if (this.customScript && this.customScript.parentNode) {
      document.body.removeChild(this.customScript);
    }
  }

  registerWithEmail() {
    sessionStorage.setItem(LocaleKeys.registerEmailFromLanding, this.registerEmail);
    this.router.navigate(['/user/register']);
  }

  getExamsLanding() {
    this.httpExamService
      .listLanding({
        perPage: 5,
      })
      .subscribe((res) => {
        const exams = res['hydra:member'].map((elt) => new Exam(elt));
        let count = 0;
        exams.forEach((exam) => {
          this.httpExamService.listOtherSpecialties(exam.id).subscribe((res) => {
            count++;
            exam.otherSpecialties = res['hydra:member'].map((elt) => new Specialty(elt));

            if (count === exams.length) {
              // nnkitodo [later] slider avec loading quand pas encore chargé
              this.exams = exams;
              setTimeout(() => {
                this.examsSwiper = new Swiper(this.examsSwiperRef.nativeElement, {
                  slidesPerView: 2.5,
                  loop: true,
                  spaceBetween: 32,
                  speed: 1000,
                  autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                  },

                  breakpoints: {
                    0: {
                      slidesPerView: 1,
                    },

                    768: {
                      slidesPerView: 2,
                    },

                    1023: {
                      slidesPerView: 2.15,
                    },

                    1180: {
                      slidesPerView: 2,
                    },

                    1200: {
                      slidesPerView: 2.5,
                    },

                    1600: {
                      slidesPerView: 3.15,
                    },

                    2200: {
                      slidesPerView: 4.5,
                    },
                  },
                });
              });
            }
          });
        });
      });
  }

  getFeaturedTestimoniesLanding() {
    this.httpFeaturedTestimonyService
      .list(
        new FeaturedTestimonyQueryData({
          publicationStatus: [FeaturedTestimonyPublicationStatus.PUBLISHED_ON_LANDING],
        })
      )
      .subscribe((res) => {
        this.landingTestimonies = res['hydra:member'].map((elt) => new FeaturedTestimony(elt));
        setTimeout(() => {
          // nnkitodo [later] slider avec loading quand pas encore chargé
          this.landingTestimoniesSwiper = new Swiper(
            this.landingTestimoniesSwiperRef.nativeElement,
            {
              slidesPerView: 1,
              loop: false,
              spaceBetween: 0,
              speed: 1000,
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            }
          );
        });
      });
  }

  getApplicationStats() {
    this.componentStore.getApplicationStats();
  }

  SSOFacebookLogin() {
    this.store
      .select(AuthSelectors.loginLoading)
      .pipe(
        take(1),
        filter((loading) => !loading)
      )
      .subscribe(() => {
        this.store.dispatch(AuthActions.SSOLoginWithSDK({ provider: SSOProvider.FACEBOOK }));
      });
  }

  SSOAppleLogin() {
    this.store
      .select(AuthSelectors.loginLoading)
      .pipe(
        take(1),
        filter((loading) => !loading)
      )
      .subscribe(() => {
        this.store.dispatch(AuthActions.SSOLoginWithSDK({ provider: SSOProvider.APPLE }));
      });
  }

  SSOGoogleLogin() {
    this.store
      .select(AuthSelectors.loginLoading)
      .pipe(
        take(1),
        filter((loading) => !loading)
      )
      .subscribe(() => {
        this.store.dispatch(AuthActions.SSOLoginWithSDK({ provider: SSOProvider.GOOGLE }));
      });
  }

  animAncrageCreated(animationItem: AnimationItem): void {
    this.animAncrage$.next(animationItem);
  }

  playAnimAncrage() {
    this.animAncrage$
      .pipe(
        filter((anim) => !!anim),
        take(1)
      )
      .subscribe((anim) => {
        anim.play();
      });
  }

  animCoursCreated(animationItem: AnimationItem): void {
    this.animCours$.next(animationItem);
  }

  playAnimCours() {
    this.animCours$
      .pipe(
        filter((anim) => !!anim),
        take(1)
      )
      .subscribe((anim) => {
        anim.play();
      });
  }

  animTrainingCreated(animationItem: AnimationItem): void {
    this.animTraining$.next(animationItem);
  }

  playAnimTraining() {
    this.animTraining$
      .pipe(
        filter((anim) => !!anim),
        take(1)
      )
      .subscribe((anim) => {
        anim.play();
      });
  }

  animTypeCreated(animationItem: AnimationItem): void {
    this.animType$.next(animationItem);
  }

  playAnimType() {
    this.animType$
      .pipe(
        filter((anim) => !!anim),
        take(1)
      )
      .subscribe((anim) => {
        anim.play();
      });
  }

  animPlayCreated(animationItem: AnimationItem): void {
    this.animPlay$.next(animationItem);
  }

  playAnimPlay() {
    this.animPlay$
      .pipe(
        filter((anim) => !!anim),
        take(1)
      )
      .subscribe((anim) => {
        anim.play();
      });
  }

  animEcosCreated(animationItem: AnimationItem): void {
    this.animEcos$.next(animationItem);
  }

  playAnimEcos() {
    this.animEcos$
      .pipe(
        filter((anim) => !!anim),
        take(1)
      )
      .subscribe((anim) => {
        anim.play();
      });
  }

  animChallengeCreated(animationItem: AnimationItem): void {
    this.animChallenge$.next(animationItem);
  }

  playAnimChallenge() {
    this.animChallenge$
      .pipe(
        filter((anim) => !!anim),
        take(1)
      )
      .subscribe((anim) => {
        anim.play();
      });
  }
}
